import React, { useEffect } from 'react'
import injectStyles from 'react-jss'
import styles from '../styles'
import LoadingIndicator from '../../LoadingIndicator/LoadingIndicator'
import cn from 'classnames'

const DrawMapView = ({
  setCursorPosition,
  controls,
  hideMapControls,
  children,
  loading,
  classes,
  isFullScreen = false,
  onFullScreen = () => {},
  fullScreenElem = null,
}) => {
  useEffect(() => {
    const closeFullscreen = () => {
      if (
        !document.fullscreenElement &&
        !document.webkitFullscreenElement &&
        !document.mozFullScreenElement &&
        !document.msFullscreenElement
      ) {
        onFullScreen(false)
        setTimeout(() => {
          fullScreenElem &&
            fullScreenElem.scrollIntoView({ behavior: 'smooth' })
        }, 100)
      }
    }

    if (isFullScreen) {
      if (fullScreenElem.requestFullscreen) {
        fullScreenElem.requestFullscreen()
      } else if (fullScreenElem.webkitRequestFullscreen) {
        /* Safari */
        fullScreenElem.webkitRequestFullscreen()
      } else if (fullScreenElem.msRequestFullscreen) {
        /* IE11 */
        fullScreenElem.msRequestFullscreen()
      }
    } else if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    ) {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.webkitExitFullscreen) {
        /* Safari */
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) {
        /* IE11 */
        document.msExitFullscreen()
      }
    }
    document.addEventListener('fullscreenchange', () => closeFullscreen())
    return () => {
      document.removeEventListener('fullscreenchange', () => closeFullscreen())
    }
  }, [isFullScreen])

  return (
    <section
      className={cn(classes.wrapper, isFullScreen && classes.fullscreen)}
      onClick={e =>
        setCursorPosition(
          {
            left: e.clientX,
            top: e.clientY,
          },
          e.currentTarget.offsetWidth,
        )
      }
    >
      <div />
      {loading && (
        <div className={classes.loadingWrapper}>
          <LoadingIndicator />
        </div>
      )}
      <div className={classes.controlsWrapper}>
        {hideMapControls ? null : controls}
      </div>
      {children}
    </section>
  )
}

export default injectStyles(styles)(DrawMapView)
